// extracted by mini-css-extract-plugin
module.exports = {"shoppingCart":"ShoppingCartHeader_shoppingCart__1Pxjb","link":"ShoppingCartHeader_link__1Tgo-","cartIcon":"ShoppingCartHeader_cartIcon__14F2n"};